import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
type Props = {
  channelId: string;
};
function GlobalServiceNoticeBanner(t0) {
  const $ = _c(3);
  const {
    channelId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-[15px] text-colorFg05">글로벌 채널에 표기될 프로필 및 BJ소개문구를 작성해 주세요!</div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `/channel/${channelId}/globalService`;
  let t3;
  if ($[1] !== t2) {
    t3 = <div className="absolute bottom-[calc(100%+2px)] flex items-center gap-[9px] whitespace-nowrap rounded-[10px] bg-colorBg_tooltip px-[8px] py-[6px] pl-[10px]">{t1}<Link href={t2} className="rounded-lg bg-colorBg15 px-2 py-[3px] text-[12px] text-colorFg04 leading-[18px]">설정</Link></div>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}
export default GlobalServiceNoticeBanner;